module.exports = __webpack_public_path__ + "static/img/hw2.840ede7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/hw/hw2.png
// module id = Kqvu
// module chunks = 0